import { Group, NakedButton } from '@melio/penny';
import { FundingSource } from '@melio/platform-api';

import { FundingSourceCard } from './FundingSourceCard';

export const FundingSourceCardList = ({
  fundingSources,
  onCardClick,
  selectedId,
  onAddClick,
  addLabel,
}: {
  fundingSources: FundingSource[];
  onCardClick: (fundingSource: FundingSource) => void;
  selectedId?: string;
  onAddClick: VoidFunction;
  addLabel: string;
}) => (
  <>
    {fundingSources.map((fundingSource) => (
      <FundingSourceCard
        key={fundingSource.id}
        fundingSource={fundingSource}
        onClick={() => onCardClick(fundingSource)}
        isSelected={selectedId === fundingSource.id}
      />
    ))}
    <Group>
      <NakedButton label={addLabel} variant="secondary" onClick={onAddClick} />
    </Group>
  </>
);
